export const PERSONAS_DOMICILIO = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6+", label: "6 o más" },
];

export const OCUPACIONES = [
  { value: "fuerzas-armadas", label: "FUERZAS ARMADAS" },
  { value: "empleado", label: "Empleado" },
  { value: "independiente", label: "Independiente" },
  { value: "estudiante", label: "Estudiante" },
  { value: "jubilado", label: "Jubilado" },
];
